<template>
  <el-container>
    <!-- 对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <span>
        <webcrawler
          ref="refCrawler"
          :crawler="crawlerData"
          @close="handleClose"
          @ok="handleOk"
        />
      </span>
    </el-dialog>
    <!--  -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><h3>网络工单列表</h3></el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button
          type="info"
          icon="el-icon-magic-stick"
          @click.native="addCrawler"
        >
          新建
        </el-button>
      </el-button-group>
    </el-header>
    <el-main>
      <el-table :data="crawlerList" style="width: 100%">
        <el-table-column align="center" type="index" label="序号">
          <template slot-scope="scope">
            <span>
              {{
                (xpagination.pageNumber - 1) * xpagination.pageSize +
                scope.$index +
                1
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="postingTime"
          label="发贴时间"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              {{ Common.dateFormatter(scope.row.postingTime, "yyyy-MM-dd") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="发贴人"
          width="150"
          align="center"
        />
        <el-table-column prop="title" label="标题">
          <template slot-scope="scope">
            <div>
              <el-button
                type="text"
                size="small"
                @click="details(scope.row.id)"
              >
                {{ scope.row.title }}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="pstSource"
          label="舆情来源"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <a :href="scope.row.pstUrl" target="_blank">{{
                scope.row.pstSource
              }}</a>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <span class="m-2">
              <el-link icon="el-icon-edit" @click="editCrawler(scope.row)">
                编辑
              </el-link>
            </span>
            <span class="m-2">
              <el-link icon="el-icon-delete" @click="deleteCrawler(scope.row)">
                删除
              </el-link>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="cust_pagin">
        <el-pagination
          layout="prev, pager, next"
          :total="xpagination.totalCount"
          :page-size="xpagination.pageSize"
          :current-page="xpagination.pageNumber"
          @current-change="handleCurrentChange"
          hide-on-single-page
          :background="true"
        />
      </div>
    </el-main>
  </el-container>
</template>
    
<script>
import webcrawler from "@/components/WebCrawler.vue";
export default {
  components: {
    webcrawler,
  },
  mounted() {
    this.getWebCrawlerList();
  },
  created() {
    this.pstApi.setWindowTitle("网络工单列表");
  },
  data() {
    return {
      queryString: "",
      crawlerList: [],
      //分页栏数据
      xpagination: {
        totalCount: 1,
        pageSize: 5,
        pageNumber: 1,
        totalPages: 1,
      },

      params: [],
      crawlerType: 1,
      //
      dialogVisible: false,
      dialogTitle: "",
      crawlerData: {},
    };
  },
  methods: {
    getWebCrawlerList() {
      this.WXPstAxios({
        method: "get",
        url: "/api/webcrawler/list",
        params: {
          QueryString: this.queryString,
          PageNumber: this.xpagination.pageNumber,
          PageSize: this.xpagination.pageSize,
        },
      })
        .then((res) => {
          this.crawlerList = res.data;
          console.log(res.data);
          var pagin = JSON.parse(res.headers.xpagination);
          //console.log(pagin)
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },

    addCrawler() {
      this.dialogTitle = "创建留言爬取参数";
      this.crawlerData = {};
      this.dialogVisible = true;
    },
    editCrawler(row) {
      this.dialogTitle = "编辑留言爬取参数";
      this.crawlerData = row;
      this.dialogVisible = true;
    },
    deleteCrawler(row) {
      this.$confirm(`确定删除【${row.title}】记录吗？`, "警告", {
        iconClass: "el-icon-warning", //自定义图标样式
        confirmButtonText: "确认", //确认按钮文字更换
        cancelButtonText: "取消", //取消按钮文字更换
        showClose: true, //是否显示右上角关闭按钮
        type: "warning", //提示类型  success/info/warning/error
      })
        .then(() => {
          this.WXPstAxios({
            method: "delete",
            url: "/api/crawlerparams/delete/" + row.id,
          }).then((res) => {
            this.getCrawlerParams();
          });
        })
        .then((data) => {
          //取消操作
        })
        .catch((err) => {
          //捕获异常
          console.log(err);
        });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleOk(data) {
      if (data.id == "") {
        //创建
        var paramString = JSON.stringify(data.params);
        this.WXPstAxios({
          method: "post",
          url: "/api/crawlerparams/create",
          data: {
            title: data.title,
            crawlerType: data.crawlerType,
            isUse: data.isUse,
            params: paramString,
          },
        }).then((res) => {
          this.dialogVisible = false;
          this.getCrawlerParams();
        });
      } else {
        //修改
        var paramString = JSON.stringify(data.params);
        this.WXPstAxios({
          method: "put",
          url: "/api/crawlerparams/update/" + data.id,
          data: {
            title: data.title,
            crawlerType: data.crawlerType,
            isUse: data.isUse,
            params: paramString,
          },
        }).then((res) => {
          this.dialogVisible = false;
          this.getCrawlerParams();
        });
      }
    },
    //分页操作
    handleCurrentChange(val) {
      this.xpagination.pageNumber = val;
      this.getWebCrawlerList();
    },
  },
};
</script>
    
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
/deep/.el-input.is- .el-input__inner {
  color: #031944;
}
/deep/.el-textarea.is- .el-textarea__inner {
  color: #031944;
}

.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.miniTool {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
//
.img-list {
  overflow: hidden;
  width: 100%;
  // 文件列表
  .img-li-box {
    float: left;
    text-align: left;
    position: relative;
    display: block; //Inline-block
    width: 200px;
    height: 270px;
    padding: 5px;
    margin: 5px 20px 20px 0;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    transition: all 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 190px;
      margin: 0 auto;
      border-radius: 4px;
    }
    // 底部
    .img-li-b--bottom {
      margin-top: 10px;
      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }
    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }
    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 200px;
      color: #fff;
      text-align: center;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);
      // 放大按钮
      i {
        font-size: 1.6em;
        margin-top: 80px;
      }
    }
    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }
    // 悬浮可见删除 or 放大按钮
    &:hover {
      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }
    // 上传进度
    &.img-li-b--progress {
      // padding: 0;
      // text-align: center;
      // padding-top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  // 上传按钮
  .img-li-b--upload {
    float: left;
    width: 200px;
    height: 270px;
    display: table;
    text-align: center;
    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }
}
.el-dialog-div {
  margin: 0 auto;
  height: 500px;
  overflow: auto;
  display: flex;
  align-items: center;
}

/deep/ .el-drawer__body {
  overflow-y: none;
  padding: 5px 5px;
  margin-bottom: 50px;
}

.demo-drawer__footer {
  width: 100%;

  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  background-color: white;
  .el-button {
    flex: 1;
  }
}

//
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>